<router-outlet></router-outlet>
<ng-template #popupTemplate let-dialogRef>
    <mat-dialog-content>
        <h2 mat-dialog-title>Session about to timeout</h2>
        <p *ngIf="idleState.message"  [innerHTML]="idleState.message"></p>
    </mat-dialog-content>
</ng-template>
